import React from 'react'
import { LoadMoreButton } from 'modules/comments/ui/load-more-button'

export interface CommentListWithLoaderProps<T extends { id: number; nextId: number | null }> {
  items: T[]
  renderItem: (item: T) => JSX.Element
  onLoadMore: ({
    lastCommentId,
    parentId,
  }: {
    lastCommentId: number
    parentId: number | null
  }) => void
  parentId?: number | null
  loadMoreLabel: string
}

export const CommentListWithLoader = <T extends { id: number; nextId: number | null }>({
  items,
  renderItem,
  onLoadMore,
  parentId = null,
  loadMoreLabel,
}: CommentListWithLoaderProps<T>) => {
  return (
    <>
      {items.map((item, index) => {
        const nextItem = items[index + 1]
        const hasGap = item.nextId !== null && (!nextItem || nextItem.id !== item.nextId)

        return (
          <React.Fragment key={item.id}>
            {renderItem(item)}
            {hasGap && (
              <LoadMoreButton
                key={`load-more-${item.id}`}
                parentId={parentId}
                lastCommentId={item.id}
                onClick={onLoadMore}
              >
                {loadMoreLabel}
              </LoadMoreButton>
            )}
          </React.Fragment>
        )
      })}
    </>
  )
}
